export default __webpack_public_path__ + "static/media/success.36df1037.png";